import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "bd6a2bbd-bf6a-4b50-b631-3243342ff9db",
    authority:
      "https://login.microsoftonline.com/09ff37ec-4e1b-42a3-a4f9-101558ae61ac", //Tenant ID
    redirectUri: process.env.REACT_APP_URL,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
